import { useState } from 'react'

import { useDeleteTag, useTags } from '../api'
import { useTagsStore } from '../store'

interface UseTagDeleteOptions {
  onSuccess?: (deletedTagId: number) => void
  onError?: (error: unknown) => void
}

/**
 * Hook to handle tag deletion functionality with API integration
 * @param options Configuration options
 * @returns Object containing tag deletion state and functions
 */
export const useTagDelete = (options: UseTagDeleteOptions = {}) => {
  const { onSuccess, onError } = options
  const [isDeleting, setIsDeleting] = useState(false)
  const { trigger: deleteTag, isMutating } = useDeleteTag()
  const { setTagsUpdating } = useTagsStore()
  useTags({ page: 1, pageSize: 100 })

  const removeTag = async (tagId: number) => {
    setIsDeleting(true)
    setTagsUpdating(true)

    return deleteTag(
      { params: { id: tagId } },
      {
        onSuccess: async () => {
          // Optimistically remove the tag from the store immediately
          const { removeTagFromGlobalState } = useTagsStore.getState()
          removeTagFromGlobalState(tagId)

          //remove the tag from store
          const { filteringTags } = useTagsStore.getState()
          const updatedFilteringTags = filteringTags.filter((tag) => tag.id !== tagId)
          useTagsStore.getState().setFilteringTags(updatedFilteringTags)

          if (onSuccess) {
            onSuccess(tagId)
          }

          setIsDeleting(false)
          setTagsUpdating(false)
        },
        onError: (error) => {
          if (onError) {
            onError(error)
          }
          setIsDeleting(false)
          setTagsUpdating(false)
        },
      },
    )
  }

  return {
    removeTag,
    isDeleting: isDeleting || isMutating,
  }
}
